<!-- Actions and filters -->
 <div class="container filters-container my-3 mx-0">
  <div class="row row-cols-3 align-items-center">
    <div class="col-md-auto">
      <label class="form-label search-label">Search:</label>
    </div>

    <div class="col-md-auto input-group-sm position-relative">
      <span class="search-icon">
        <i class="fas fa-search"></i>
      </span>
      <input type="text"
             [value]="nameFilterText"
             class="form-control search-by"
             placeholder="by Name"
             (keyup)="onKeyUpName($event.target.value)" />
      <button *ngIf="nameFilterText.length > 0"
              class="btn btn-link cross-input"
              (click)="clearNameFilter()">
        <i class="fas fa-times-circle"></i>
      </button>
    </div>
   
    <div class="col-md-auto input-group-sm position-relative">
      <span class="search-icon">
        <i class="fas fa-search"></i>
      </span>
      <input type="text"
             class="form-control search-by"
             placeholder="by Email"
             [value]="emailFilterText"
             (keyup)="onKeyUpEmail($event.target.value)" />
      <button *ngIf="emailFilterText.length > 0"
              class="btn btn-link cross-input"
              (click)="clearEmailFilter()">
        <i class="fas fa-times-circle"></i>
      </button>
    </div>

    <div class="col col-md-5">
       <div class="row">
          <div class="col-md-auto">
            <input type="checkbox"
                   class="form-check-input"
                   id="inactiveCheckbox"
                   (click)="onChange($event.target.checked)"
                   [checked]="checkInactive" />
            <label class="form-check-label" for="inactiveCheckbox">Inactive</label>
          </div>
          <div class="col-md-auto" *ngIf="ownedByOrg">
            <input type="checkbox"
                   class="form-check-input"
                   id="ownershipCheckbox"
                   (click)="onChangeOwnership($event.target.checked)" />
            <label class="form-check-label" for="ownershipCheckbox">Owned by organization</label>
          </div>
          <div class="col-md-auto">
            <input type="checkbox"
                   class="form-check-input"
                   id="deletedCheckbox"
                   (click)="onChangeDeleted($event.target.checked)" />
            <label class="form-check-label" for="deletedCheckbox">Deleted</label>
          </div>
        </div>
      </div>
  </div>
</div>
